import React from "react";
import { Link, useParams } from "react-router-dom";
import { ScrollView } from "native-base";
import { Protocol } from "../WebAccess";
import TenantLogo from "./TenantLogo";
import AllObjectsArchiveDownload from "./AllObjectsArchiveDownload";
import { getBackendURL } from "../../../environment";

type Props = {
  protocols: Protocol[];
  code: string;
};

export default function WebProtocolSelector({ protocols, code }: Props) {
  const { projectOrObjectId } = useParams();

  const firstProtocol = protocols[0];

  const downloadUrl = new URL(`${getBackendURL()}/archive/pdfs`);
  downloadUrl.searchParams.append("code", code);
  downloadUrl.searchParams.append("projectOrObjectId", projectOrObjectId!);

  return (
    <ScrollView height="100vh">
      <div
        className="webprotocol"
        style={
          {
            "--primary-color": firstProtocol?.tenant?.primaryColor,
          } as React.CSSProperties
        }
      >
        <TenantLogo tenant={firstProtocol?.tenant} />

        <h1>Rissprotokolle</h1>

        {protocols.map((protocol, idx) => {
          const { title, owner, protocolPDFUrl } = protocol;

          return (
            <div key={protocolPDFUrl}>
              <h2>{title}</h2>

              <div className="with-line-breaks">{owner}</div>

              <div>
                <Link to={`${idx}`}>Zum Webprotokoll</Link>
              </div>

              <div>
                <a
                  href={protocolPDFUrl}
                  download={`${title}.pdf`}
                  target="_blank"
                >
                  Als PDF herunterladen
                </a>
              </div>
            </div>
          );
        })}

        <h2>Download</h2>

        <h3>Rissprotokolle</h3>

        <a
          href={downloadUrl.toString()}
          download="Rissprotokolle.zip"
          target="_blank"
        >
          Alle Rissprotokolle herunterladen (ZIP-Archiv)
        </a>

        <h3>Fotos</h3>

        <AllObjectsArchiveDownload code={code} />
      </div>
    </ScrollView>
  );
}
